import { Grid } from "@mui/material";


import { TextInput } from "../../../../shared/ui/common/index.js";

const Social = ({ data, setData }) => {

  return (
    <Grid container gap={3}>
      <Grid item xs={12} sm={6} md={4} lg={3} className="leftInput">
        <TextInput
          label="لینک واتساپ "
          currentValue={data?.socialAddress1}
          change={(e) => setData({ ...data, socialAddress1: e })}
          
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}  className="leftInput">
        <TextInput
          label="لینک تلگرام "
          currentValue={data?.socialAddress2}
          change={(e) => setData({ ...data, socialAddress2: e })}
          
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}  className="leftInput">
        <TextInput
          label="لینک اینستاگرام "
          currentValue={data?.socialAddress3}
          change={(e) => setData({ ...data, socialAddress3: e })}
          
        />
      </Grid>
    </Grid>
  );
};

export default Social;
